import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_NOTICE, ADD_NOTICE_FAILED, ADD_NOTICE_SUCCESS, NOTICE, NOTICE_FAILED, NOTICE_SUCCESS, UPDATE_NOTICE, UPDATE_NOTICE_FAILED, UPDATE_NOTICE_SUCCESS } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"


export const getNotices = () => async (dispatch) => {
  dispatch({
    type: NOTICE,
  });
  try {
    let response = await api(`notice/noticeList`, "get", {}, getAuthHeader());
    dispatch({
      type: NOTICE_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Notice list error ====>", error);
    return dispatch({
      type: NOTICE_FAILED,
      payload: error?.message,
    });
  }
};

export const addNotice = (data) => async dispatch => {
  dispatch({
    type: ADD_NOTICE
  })
  try {
    let response = await api(`notice/add`, 'post', data, getAuthHeader())
    console.log('add notice data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_NOTICE_SUCCESS,
      payload: response?.data
    })
    await dispatch(getNotices())
    return response
  } catch (error) {
    console.log("while Adding notice error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_NOTICE_FAILED,
      payload: error?.message
    })
  }
}

export const updateNotice = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_NOTICE
  })
  try {
    let response = await api(`notice/update/${id}`, 'put', data, getAuthHeader())
    console.log('update notice data', response);
    toast.success("Updated Successfully");
      await dispatch(getNotices())
    dispatch({
      type: UPDATE_NOTICE_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while updating notice error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_NOTICE_FAILED,
      payload: error?.message
    })
  }
}